import { overview } from "./overview";
export const translations = {
  ar: {
    brand: "هاير هوست",
    tagline: "استضافةً لغدٍ أفضل",
    nav: {
      home: "الرئيسية", about: "من نحن", about_company: "عن شركتنا", meet_team: "تعرف على فريقنا",
      employers: "أصحاب العمل", overview: "نظرة عامة", place_order: "قدّم طلب عمالة",
      solutions: "حلولنا", our_solutions: "حلول التوظيف", staffing_service: "خدمات التوظيف المؤقت",
      jobseekers: "الباحثون عن عمل", js_overview: "نظرة عامة", job_openings: "الوظائف الشاغرة",
      apply_now: "قدّم الآن", faq: "الأسئلة الشائعة", testimonials_menu: "آراء العملاء",
      contact: "اتصل بنا", employer_login: "دخول أصحاب العمل", employee_login: "دخول المرشحين",
      inquire: "اطلب عمالة", admin: "الإدارة",
    },
    hero: {
      overline: "معتمدون من وزارة الشؤون الخارجية الهندية • ISO 9001:2015",
      l1: "توظيف دقيق.", l2: "كفاءات مختارة بعناية.", l3: "نتائج مضمونة.",
      sub: "منذ 1998 نربط أفضل الكفاءات الهندية بأصحاب العمل في الخليج — من السائقين والفنيين إلى المهندسين والكوادر الطبية. ترخيص حكومي كامل وبوابة متابعة لحظية لكل تأشيرة.",
      cta1: "اطلب عمالة الآن", cta2: "تصفح الوظائف", scroll: "مرر للاستكشاف",
    },
    stats: { years: "سنة خبرة", companies: "شركة شريكة", recruitments: "عملية توظيف", industries: "قطاعاً صناعياً" },
    marquee: ["ترخيص وزارة الخارجية الهندية: B-0377/MOM/PER/+1000/5/5037/98", "ISO 9001:2015 — Bureau Veritas", "بطاقة القنصلية السعودية: 354/98/23/E", "مسجلون في سوق الأمم المتحدة العالمي", "عضو الغرفة التجارية الهندية", "مركز التصديق والبصمة وQVP"],
    aboutsec: {
      overline: "عن وكالتنا",
      title: "مرحباً بكم في هاير هوست إنديا",
      body: "لأكثر من ثلاثة عقود، كانت هاير هوست ركيزة أساسية في قطاع التوظيف، متخصصة في ربط أفضل الكفاءات الهندية بأكبر الشركات في الخليج، وخاصة في المملكة العربية السعودية. عملاؤنا المميزون يتراوحون بين شركات متعددة الجنسيات ومؤسسات محلية بارزة تعتمد علينا لتلبية احتياجاتها من العمالة بدقة وتميز. تغطي خدماتنا الشاملة طيفاً واسعاً من الأدوار — من العمالة الماهرة والفنيين إلى المهندسين والأطباء. نفخر بعملية الاختيار الصارمة لدينا، التي تضمن أن كل مرشح نقدمه يلبي أعلى معايير الاحترافية والخبرة. معرفتنا العميقة بالقطاع والتزامنا الراسخ بالجودة يمكناننا من تقديم كفاءات استثنائية تقود نجاح عملائنا.",
    },
    welcome: {
      overline: "مرحباً بكم في هاير هوست إنديا",
      title: "وكالة توظيف العصر الحديث",
      sub: "نعيد تعريف استقطاب الكفاءات: كيف تتكيف وكالات التوظيف الحديثة مع احتياجات القوى العاملة المتطورة في العصر الرقمي.",
      emp_t: "لأصحاب العمل",
      emp_d: "اعثر على الكفاءة المثالية لمنشأتك بسهولة — من فهم احتياجك حتى التعيين النهائي، نجعل التوظيف بسيطاً وفعالاً.",
      emp_points: ["نفهم احتياجك بدقة", "نجد المرشح المثالي", "مطابقة مخصصة لكل دور", "استقطاب وتوظيف سريع"],
      job_t: "للباحثين عن عمل",
      job_d: "اكتشف مسارك المهني مع هاير هوست — وظيفتك المناسبة في الخليج بانتظارك.",
      job_points: ["اكتشف مسارك المهني", "مجانية عندما تتحمل الشركة رسومنا", "أدلة وموارد تعليمية", "تحديثات لحظية لطلبك"],
      explore: "اعرف المزيد",
    },
    how: {
      overline: "كيف نعمل",
      title: "خطتنا وأسلوب عملنا",
      sub: "عملية انسيابية تضمن وصول الكفاءة الصحيحة إلى الفرصة الصحيحة بكفاءة تامة.",
      steps: [
        { t: "استلام الطلب من صاحب العمل", d: "نبدأ عمليتنا بالتعاون الوثيق مع أصحاب العمل لفهم احتياجاتهم الخاصة من العمالة. فريقنا يجري نقاشات تفصيلية لتوثيق كل متطلب، بما يضمن توافقنا الكامل مع توقعات صاحب العمل ومعاييره — لنقدم مرشحين يناسبون الدور وثقافة المنشأة تماماً." },
        { t: "فرز الطلبات وجدولة المقابلات", d: "عملية الفرز الدقيقة لدينا تضمن أن المرشحين الأكثر كفاءة فقط هم من يصلون إليكم. نقيّم الطلبات وفق معايير صارمة، ونجري فحوصات خلفية شاملة، ونرتب مقابلات لتقييم المهارات والتوافق — لضمان تطابق مثالي بين الطرفين." },
        { t: "ختم التأشيرة والتعبئة السريعة", d: "بعد الفرز والاختيار النهائي، نتحرك بسرعة لتجهيز المرشحين للإرسال. نتولى جميع إجراءات ختم التأشيرة بدقة وكفاءة مع الامتثال الكامل للمتطلبات التنظيمية — وخلال 15 يوماً نرسل المرشحين المختارين إلى السعودية، بما يقلل فترة التوقف إلى أدنى حد." },
      ],
    },
    history: {
      overline: "تاريخنا",
      title: "نظرة على مسيرتنا",
      items: [
        { year: "1999", t: "البداية في مومباي", d: "تأسست هاير هوست في مومباي كوكالة توظيف طموحة، مكرّسة لتقديم عمالة عالية الجودة للشركات المحلية." },
        { year: "2001", t: "شركة سريعة النمو", d: "خلال عامين فقط، سمعتنا في التميز جعلتنا من أسرع شركات التوظيف نمواً في المنطقة." },
        { year: "2004", t: "جائزة أفضل كفاءات توظيف", d: "تكريم كبير لالتزامنا بالجودة — جائزة أفضل كفاءات توظيف عن ممارساتنا المبتكرة." },
        { year: "2007", t: "100 شراكة مع الشركات", d: "شراكات مع 100 شركة محلية أصبحت حل التوظيف الموثوق لها — شهادة على قوة خدمتنا." },
        { year: "2010", t: "توسيع الآفاق", d: "توسعنا خارج الحدود المحلية لتلبية الطلب المتنامي على العمالة الماهرة في الخليج، خاصة السعودية." },
        { year: "2013", t: "شهادة ISO", d: "التزامنا بأعلى معايير الجودة توّج بالحصول على شهادة ISO العالمية." },
        { year: "2015", t: "اعتراف عالمي", d: "سعينا الدؤوب للتميز أكسبنا عدة جوائز عالمية في قطاع التوظيف الدولي." },
        { year: "2017", t: "تطورات تقنية", d: "تبنينا أحدث التقنيات لتبسيط عمليات التوظيف — سرعة وكفاءة وضعت معايير جديدة في القطاع." },
        { year: "2020", t: "مرونة ونمو", d: "رغم التحديات العالمية، أظهرنا مرونة استثنائية وواصلنا النمو والتوسع." },
        { year: "2023", t: "ريادة القطاع", d: "بخبرة تتجاوز عقدين وجوائز متعددة وحضور عالمي قوي، تقف هاير هوست كقائد في قطاع استقدام العمالة." },
      ],
    },
    manifesto: {
      overline: "لماذا نحن", title: "أربعة فصول من الثقة",
      c1t: "إرث 25+ عاماً", c1d: "منذ 1998 ونحن نبني جسور العمل بين الهند والخليج. آلاف الشركات وثقت بنا، وعشرات الآلاف من العائلات بدأت حياة جديدة عبرنا.",
      c2t: "قانوني 100% ومعتمد حكومياً", c2d: "ترخيص وزارة الشؤون الخارجية الهندية، بطاقة القنصلية السعودية، وتسجيل في سوق الأمم المتحدة العالمي. كل تأشيرة تمر عبر القنوات الرسمية فقط.",
      c3t: "اختبارات مهارة دقيقة", c3d: "مختبرات اختبار مهني، مقابلات تقنية عبر زوم، وشهادات QVP — لا نرسل إلا من اجتاز المعيار الكامل.",
      c4t: "إرسال بدون تأخير", c4d: "من التأشيرة إلى بوابة الطائرة: بصمة، تصديق، ختم، وتوجيه ما قبل السفر — كل ذلك تحت سقف واحد في مومباي.",
    },
    solutions: {
      overline: "حلولنا", title: "حلول توظيف ملهمة",
      sub: "حلول مبتكرة مصممة لاحتياجاتك — خبرة قطاعية مع تقنية حديثة عبر كل نماذج التوظيف.",
      more: "التفاصيل",
      items: [
        { t: "التوظيف المؤقت", d: "غطِّ احتياجاتك قصيرة المدى بسرعة مع حلولنا المؤقتة المرنة." },
        { t: "التعيين المباشر", d: "اعثر على الإضافة الدائمة المثالية لفريقك عبر خدمات التعيين المباشر." },
        { t: "التعاقد", d: "استعن بكفاءات متخصصة لمشاريع محددة أو مهام زمنية محدودة." },
        { t: "إدارة الرواتب", d: "بسّط عمليات التوظيف والرواتب مع حلول الإدارة الكاملة." },
        { t: "البحث التنفيذي", d: "تواصل مع قيادات من الطراز الأول عبر خدمة البحث التنفيذي." },
        { t: "التدريب والتطوير", d: "تأهيل المرشحين بتدريب مهني متخصص قبل الإرسال." },
      ],
    },
    staffing: {
      overline: "خدمات التوظيف",
      title: "حلول توظيف لكل حالة طارئة",
      items: [
        { t: "التوظيف قصير المدى", d: "حلول مرنة لتغطية المواسم والمشاريع والفجوات المؤقتة — كفاءات ماهرة بعقود مرنة دون التزامات طويلة." },
        { t: "التوظيف في اللحظة الأخيرة", d: "احتياجات مفاجئة؟ لدينا مجموعة مرشحين مفحوصين مسبقاً جاهزون للالتحاق فوراً دون أي مساس بالجودة." },
        { t: "التوظيف الفوري", d: "سدّ الشواغر الطارئة فوراً — مرشحون مؤهلون جاهزون للبدء من اليوم الأول لضمان استمرارية عملياتك." },
      ],
    },
    tech: {
      overline: "تقنيات التوظيف", title: "نحل التوظيف بالتقنية",
      sub: "نستخدم أحدث الأدوات والمنصات لتبسيط كل مرحلة — من البحث عن المرشح حتى التعيين.",
      items: [
        { t: "أكبر قاعدة بيانات في الهند مع بحث ذكي", d: "استفد من أوسع قاعدة كفاءات في الهند — خوارزمياتنا تحدد أنسب المرشحين فوراً." },
        { t: "دخول خاص باسم مستخدم وكلمة مرور", d: "تجربة بوابة آمنة ومخصصة لكل عميل وكل مرشح." },
        { t: "تتبع وتحديثات لحظية", d: "تتبع فوري طوال عملية التوظيف — من الطلب حتى الإرسال." },
        { t: "حلول توظيف آلية", d: "أنظمة آلية تقلل الجهد اليدوي وتسرّع دورة التوظيف." },
      ],
    },
    industries: { overline: "قطاعات خدماتنا", title: "الصناعات التي نخدمها", sub: "من المستشفيات إلى أحواض بناء السفن — كفاءات لكل قطاع." },
    vacancies: {
      overline: "مباشر الآن", title: "أحدث الوظائف الشاغرة",
      sub: "فرص محدثة من عملائنا في الخليج — قدم اليوم وابدأ رحلتك.",
      all: "الكل", openings: "شاغر", salary: "الراتب الشهري", apply: "قدم الآن",
      empty: "لا توجد وظائف حالياً — تابعنا قريباً",
    },
    hires: {
      overline: "قصص نجاح", title: "آخر المرشحين المعينين",
      sub: "وجوه حقيقية سافرت هذا الشهر إلى الخليج عبر هاير هوست.", verified: "موثق",
    },
    process: {
      overline: "رحلتك خطوة بخطوة", title: "من الطلب إلى الطائرة",
      steps: [
        { t: "الاختيار والاستقطاب", d: "نستقبل الطلب وننتقي المرشحين من قاعدة بياناتنا المنتشرة في كل الهند." },
        { t: "مقابلة زوم", d: "مقابلة تقنية مباشرة بين صاحب العمل والمرشح عبر زوم أو حضورياً." },
        { t: "القائمة المختصرة", d: "ترشيح القائمة النهائية واعتمادها من صاحب العمل." },
        { t: "الفحص الطبي", d: "فحص GAMCA الطبي المعتمد لدول الخليج." },
        { t: "البصمة البيومترية", d: "تسجيل البصمة في المراكز المعتمدة." },
        { t: "اختبار المهارة / QVP / التصديق", d: "اختبار مهني وشهادة QVP وتصديق الوثائق (للمحترفين فقط)." },
        { t: "ختم التأشيرة", d: "ختم التأشيرة عبر قنصلية مومباي أو دلهي." },
        { t: "التوجيه والسفر", d: "توجيه ما قبل المغادرة ثم الصعود إلى الطائرة." },
      ],
    },
    teambehind: {
      overline: "الفريق وراءنا", title: "خبرتنا وفريقنا",
      body: "تجمع وكالتنا بين خبرة واسعة وفريق متخصص من الخبراء لتقديم حلول توظيف مصممة خصيصاً. نحن نتفهم تحديات إيجاد الكفاءات الماهرة في سوق اليوم، وملتزمون بربطك بالمحترفين المناسبين بسرعة وكفاءة.",
      temporary: "توظيف مؤقت", contract: "تعاقد", direct: "تعيين مباشر", payrolling: "إدارة رواتب",
      meet_all: "تعرف على كل أعضاء الفريق",
      leadership: "الفريق القيادي", leadership_sub: "مجلس الإدارة وكبار التنفيذيين",
      executive: "الفريق التنفيذي", executive_sub: "الفريق وراء خدمتنا الناجحة",
      r_founder: "المؤسس", r_mkt: "رئيس التسويق الخارجي", r_ta: "مدير استقطاب الكفاءات (خارجي)",
      r_hrexec: "تنفيذي موارد بشرية", r_tms: "أخصائي إدارة الكفاءات", r_hrofficer: "مسؤول موارد بشرية",
      r_hradmin: "مدير شؤون الموارد البشرية", r_chro: "الرئيس التنفيذي للموارد البشرية (CHRO)",
      r_hrgen: "أخصائي موارد بشرية عام", r_training: "التدريب والتطوير",
    },
    testisec: { overline: "آراء العملاء", title: "أعلى معدل رضا للعملاء" },
    testis: [
      { q: "العمل مع هاير هوست غيّر عملية التوظيف لدينا تماماً. كشركة نفط رائدة، نحتاج كفاءات ماهرة للحفاظ على معاييرنا العالية.", n: "معتز الريامي", c: "تنمية نفط عمان" },
      { q: "فهمهم الدقيق لاحتياجاتنا الخاصة جعل عملية التوظيف سلسة تماماً.", n: "فهد آل ثاني", c: "مدير الموارد البشرية — فرندلي فود قطر" },
      { q: "هاير هوست أكثر من شريك توظيف — هم جزء حيوي من نجاح أعمالنا.", n: "عبدالله الجهني", c: "شركة العنود العربية للتجارة" },
      { q: "شريك استثنائي في تلبية احتياجاتنا من العمالة. نثق بهم ولم يخيبوا ظننا أبداً.", n: "نياف الشمري", c: "بتيل للتمور — السعودية" },
      { q: "احترافيتهم والتزامهم بإيجاد المرشحين المناسبين كان مذهلاً حقاً.", n: "أحمد كايا", c: "مجموعة داماتي — تركيا" },
    ],
    awardssec: { overline: "تميزنا", title: "الجوائز والإنجازات الكبرى", sub: "منذ 1999 وحتى اليوم — رحلة من التكريمات التي تعكس التزامنا بالجودة والابتكار." },
    awards: [
      { year: "1999–2001", t: "التأسيس والتقدير المبكر", d: "انطلقنا في مومباي وصُنفنا ضمن أسرع شركات التوظيف نمواً في المنطقة." },
      { year: "2004", t: "جائزة أفضل كفاءات توظيف", d: "جائزة مرموقة مقابل خدمة استثنائية وممارسات توظيف مبتكرة." },
      { year: "2007", t: "100 شراكة مع الشركات", d: "علامة فارقة: شراكات مع 100 شركة تثبت ثقة القطاع المتنامية." },
      { year: "2010–2013", t: "التوسع الخليجي وشهادة ISO", d: "توسعنا في السعودية والخليج، وحصلنا على ISO وجوائز عالمية عدة." },
    ],
    clientssec: { overline: "شركاء النجاح", title: "عملاء يثقون بنا" },
    faq: {
      overline: "الأسئلة الشائعة", title: "كل ما تحتاج معرفته",
      sub: "إجابات على أكثر الأسئلة شيوعاً من أصحاب العمل والمرشحين.",
      items: [
        { q: "ما هي الخدمات التي تقدمونها؟", a: "التوظيف المؤقت، التعيين المباشر، التعاقد، إدارة الرواتب، البحث التنفيذي والتدريب — عبر أكثر من 12 قطاعاً صناعياً." },
        { q: "كيف أبدأ التوظيف معكم؟", a: "أرسل طلبك عبر نموذج الاستفسار مع خطاب الطلب — يتواصل معك فريقنا خلال 24 ساعة لتوثيق كل التفاصيل." },
        { q: "ما هي عملية اعتماد المرشحين؟", a: "نوثق احتياجك، ثم الاستقطاب، ثم مقابلات زوم، ثم القائمة المختصرة — وأنت من يعتمد الاختيار النهائي." },
        { q: "كم تستغرق مدة الإرسال؟", a: "من 4 إلى 8 أسابيع إجمالاً. بعد الاختيار النهائي، يتم ختم التأشيرة وإرسال المرشحين إلى السعودية خلال 15 يوماً." },
        { q: "هل يدفع المرشحون أي رسوم؟", a: "يعتمد ذلك على الشركة. إذا كانت الشركة تتحمل رسومنا فالخدمة مجانية بالكامل للمرشح، وإلا تُطبَّق رسوم خدمة جزئية فقط." },
        { q: "ما هو التوظيف التعاقدي؟", a: "استقطاب كفاءات متخصصة لمشاريع أو فترات محددة — خبرة مناسبة في الوقت المناسب دون التزامات طويلة." },
        { q: "ما هي الدول التي تخدمونها؟", a: "السعودية، الإمارات، قطر، الكويت، البحرين وعُمان — عبر قنصليتي مومباي ودلهي." },
        { q: "ما الوثائق المطلوبة من المرشح؟", a: "جواز ساري لمدة سنة على الأقل، صور شخصية، وشهادات مصدقة للفئات المحترفة فقط." },
      ],
    },
    apply: {
      overline: "قدّم الآن", title: "وظيفة أحلامك تبدأ هنا",
      sub: "نحن ملتزمون بتلبية احتياجاتك المهنية الفريدة. املأ النموذج وسنتواصل معك قريباً.",
      name: "الاسم الكامل", phone: "رقم الجوال", email: "البريد الإلكتروني",
      category: "الفئة المهنية", experience: "سنوات الخبرة", gulf: "خبرة خليجية؟",
      city: "المدينة الحالية", notes: "أخبرنا عن نفسك", submit: "إرسال الطلب",
      success: "تم استلام طلبك! سيتواصل معك فريق التوظيف قريباً.", error: "حدث خطأ — حاول مرة أخرى",
    },
    contact: {
      overline: "اتصل بنا", title: "لنتحدث عن احتياجك",
      sub: "حلول أعمال أذكى وعلاقات أفضل — فريقنا جاهز للإجابة على كل استفساراتك.",
      location: "العنوان", hours_t: "ساعات العمل", hours: "السبت – الخميس: 11 صباحاً – 5 مساءً • الجمعة: مغلق",
      looking: "ما الذي تبحث عنه؟", hiring: "توظيف موظفين", job: "أبحث عن وظيفة",
      message: "رسالتك", send: "إرسال الرسالة", success: "وصلتنا رسالتك! سنرد عليك قريباً.",
      call_email: "اتصل أو راسلنا",
    },
    employer: {
      overline: "بوابة أصحاب العمل", title: "اطلب العمالة المناسبة لمنشأتك",
      tc_title: "الشروط والأحكام",
      tc: [
        "تقديم خطاب الطلب (Demand Letter) ووكالة قانونية (Power of Attorney) موثقين من الغرفة التجارية والقنصلية الهندية.",
        "إرفاق نسخة من التأشيرات أو رقم التفويض الإلكتروني (Wakala).",
        "تُطبَّق رسوم استقدام حسب الفئة والقطاع — لا رسوم استقدام على العمالة، وتُحدَّد رسوم الفئات المهنية والمتخصصة بالاتفاق.",
        "مدة المعالجة التقريبية: 4 إلى 8 أسابيع حسب الفئة والقنصلية.",
        "ضمان استبدال المرشح خلال 3 أشهر وفق شروط الاتفاق.",
        "جميع المرشحين يخضعون لفحص طبي معتمد واختبار مهارة قبل السفر.",
      ],
      cats_title: "الفئات التي نوفرها", form_title: "نموذج الاستفسار",
      form_sub: "أضف كل فئة تحتاجها مع تفاصيلها، ثم أرسل الطلب — سيتواصل معك فريقنا خلال 24 ساعة.",
    },
    employee: {
      overline: "بوابة الباحثين عن عمل", title: "وظيفتك في الخليج تبدأ من هنا",
      tc_title: "شروط التقديم",
      tc: [
        "جواز سفر ساري المفعول لمدة لا تقل عن سنة.",
        "اجتياز الفحص الطبي المعتمد (GAMCA).",
        "اجتياز المقابلة التقنية واختبار المهارة للفئات الفنية.",
        "قد تُطبَّق رسوم خدمة الوكالة حسب الشركة: إذا كانت الشركة تتحمل رسومنا فالخدمة مجانية لك، وإلا تُطبَّق رسوم خدمة جزئية فقط. لا تدفع أبداً لأي وسيط غير مرخص.",
        "الوثائق التعليمية مصدقة للفئات المحترفة فقط.",
        "التزام كامل بعقد العمل وقوانين بلد الوجهة.",
      ],
      jobs_title: "أحدث الوظائف", cta: "قدّم طلبك الآن",
    },
    form: {
      company_name: "اسم الشركة / المنشأة", entity_type: "نوع المنشأة",
      muassasa: "مؤسسة", shirka: "شركة", individual: "فرد",
      contact_person: "الشخص المسؤول", phone: "رقم الجوال", email: "البريد الإلكتروني",
      category: "الفئة المطلوبة", category_other: "اكتب الفئة", workers: "عدد العمال",
      salary: "الراتب (ريال سعودي)", profession_visa: "المهنة في التأشيرة",
      experience: "سنوات الخبرة المطلوبة", years: "سنوات",
      gulf_exp: "خبرة خليجية؟", gulf_hint: "إذا اخترت «لا» فالخبرة الهندية مقبولة",
      yes: "نعم", no: "لا", consulate: "القنصلية", mumbai: "مومباي", delhi: "دلهي",
      driver_license: "رخصة القيادة", with_saudi: "برخصة سعودية", without_license: "بدون رخصة سعودية",
      driver_for: "السائق لـ", house: "منزل", company: "شركة",
      duty: "ساعات الدوام", hours: "ساعات", shift: "الشفت",
      add_category: "أضف هذه الفئة", added: "الفئات المضافة", remove: "حذف",
      notes: "ملاحظات إضافية", submit: "أرسل الطلب",
      success: "تم استلام طلبك! سيتواصل معك فريقنا خلال 24 ساعة.",
      error: "حدث خطأ — حاول مرة أخرى", required: "أضف فئة واحدة على الأقل",
    },
    categories: {
      healthcare: "الرعاية الصحية", construction: "البناء والتشييد", oilgas: "النفط والغاز",
      transport: "النقل والمعدات الثقيلة", mechanical: "الصناعات الميكانيكية", business: "إدارة الأعمال",
      finance: "المالية والمحاسبة", garment: "صناعة الملابس", fabrication: "التصنيع واللحام",
      shipbuilding: "بناء وإصلاح السفن", hospitality: "الضيافة والفنادق", it: "تقنية المعلومات",
      skilled: "عمالة ماهرة", unskilled: "عمالة غير ماهرة", driver: "سائق (ثقيل / خفيف)", other: "أخرى",
    },
    login: {
      employer_title: "دخول أصحاب العمل", employee_title: "دخول المرشحين",
      email: "البريد الإلكتروني", password: "كلمة المرور", submit: "دخول",
      soon: "البوابة قيد الإطلاق قريباً — سيتم تفعيل الدخول قريباً", back: "العودة للرئيسية",
    },
    admin: {
      login_title: "لوحة تحكم هاير هوست", login_sub: "دخول الإدارة فقط",
      vacancies: "الوظائف", hires: "المعينون", inquiries: "الاستفسارات", applications: "طلبات التوظيف",
      add_vacancy: "إضافة وظيفة", add_hire: "إضافة مرشح",
      title_field: "المسمى الوظيفي", country: "الدولة", industry: "القطاع",
      salary: "الراتب", currency: "العملة", openings: "عدد الشواغر",
      name: "الاسم", profession: "المهنة", visa_status: "حالة التأشيرة",
      photo: "الصورة", photo_url: "أو رابط صورة خارجي",
      save: "حفظ", delete: "حذف", logout: "خروج", status: "الحالة",
      new: "جديد", contacted: "تم التواصل", closed: "مغلق",
      no_inquiries: "لا توجد استفسارات بعد", no_applications: "لا توجد طلبات بعد",
      saved: "تم الحفظ بنجاح", deleted: "تم الحذف",
      login_success: "مرحباً بك", login_error: "بيانات الدخول غير صحيحة",
    },
    footer: {
      about: "وكالة توظيف دولية معتمدة حكومياً — نربط الكفاءات الهندية بأصحاب العمل في الخليج منذ 1998.",
      contact: "تواصل معنا", for_employers: "لأصحاب العمل", for_employees: "للباحثين عن عمل",
      office: "مكتب رقم 713، مبنى 3، نافجيفان سوسايتي، لامينغتون رود، مومباي سنترال (شرق)، مومباي 400008",
      rights: "جميع الحقوق محفوظة", license: "ترخيص: B-0377/MOM/PER/+1000/5/5037/98", links: "روابط سريعة",
    },
  },

  en: {
    brand: "Hire Host",
    tagline: "Hosting for a Better Tomorrow",
    nav: {
      home: "Home", about: "About", about_company: "About Our Company", meet_team: "Meet Our Team",
      employers: "Employers", overview: "Overview", place_order: "Place a Job Order",
      solutions: "Solutions", our_solutions: "Our Solutions", staffing_service: "Staffing Services",
      jobseekers: "Job Seekers", js_overview: "Overview", job_openings: "Job Openings",
      apply_now: "Apply Now", faq: "FAQ", testimonials_menu: "Testimonials",
      contact: "Contact", employer_login: "Employer Login", employee_login: "Candidate Login",
      inquire: "Request Manpower", admin: "Admin",
    },
    hero: {
      overline: "Licensed by Ministry of External Affairs, Govt. of India • ISO 9001:2015",
      l1: "Precision Hiring.", l2: "Elite, Hand-Picked Talent.", l3: "Guaranteed Results.",
      sub: "Since 1998 we have connected India's finest workforce with Gulf employers — from drivers and technicians to engineers and medical staff. Fully government-licensed, with live tracking for every visa.",
      cta1: "Request Manpower", cta2: "Explore Vacancies", scroll: "Scroll to explore",
    },
    stats: { years: "Years of Experience", companies: "Company Tie-ups", recruitments: "Recruitments Delivered", industries: "Industry Verticals" },
    marquee: ["MEA Licence: B-0377/MOM/PER/+1000/5/5037/98", "ISO 9001:2015 — Bureau Veritas", "Saudi Consulate Card: 354/98/23/E", "UN Global Marketplace Registered", "Indian Merchant Chamber Member", "Biometric • QVP • Attestation Hub"],
    aboutsec: {
      overline: "About Our Agency",
      title: "Welcome to Hire Host India",
      body: "For over three decades, Hire Host has been a cornerstone in the recruitment industry, specializing in connecting the finest Indian talent with leading companies across the Gulf, particularly in Saudi Arabia. Our esteemed clients range from multinational corporations to prominent local enterprises, who rely on us to fulfill their manpower needs with precision and excellence. Our comprehensive services cover a diverse spectrum of roles — from skilled laborers and technicians to engineers and doctors. We pride ourselves on our rigorous selection process, ensuring that every candidate we present meets the highest standards of professionalism and expertise. Our deep-rooted industry knowledge and unwavering commitment to quality enable us to deliver exceptional talent that drives our clients' success.",
    },
    welcome: {
      overline: "Welcome to Hire Host India",
      title: "The Modern-Day Staffing Agency",
      sub: "Redefining talent acquisition: how a modern staffing agency adapts to the evolving workforce needs of the digital age.",
      emp_t: "For Employers",
      emp_d: "Discover the ideal talent for your organization with ease. From initial understanding to final placement, we make hiring straightforward and efficient.",
      emp_points: ["Understand Your Needs", "Find the Perfect Candidate", "Tailored Matching", "Swift Onboarding"],
      job_t: "For Job Seekers",
      job_d: "Explore your career path with Hire Host India — your skills find their right place in the Gulf.",
      job_points: ["Explore Your Career Path", "Free When the Employer Bears Our Charges", "Educational Resources & Guides", "Real-Time Application Updates"],
      explore: "Learn More",
    },
    how: {
      overline: "How We Work",
      title: "Our Plan & Working Style",
      sub: "A streamlined process that ensures the right talent meets the right opportunity — efficiently and seamlessly.",
      steps: [
        { t: "Receive Demand from Employer", d: "We initiate our process by closely collaborating with our esteemed employers to understand their specific manpower needs. Our team engages in detailed discussions to capture every requirement, ensuring we are aligned with the employer's expectations and standards — delivering candidates who perfectly fit the job roles and organizational culture." },
        { t: "Application Screening & Scheduling", d: "Our meticulous screening process ensures that only the most qualified candidates are considered. We evaluate applications against strict criteria, conduct thorough background checks, and arrange interviews to assess skills and compatibility — presenting only the best candidates for a seamless match." },
        { t: "Visa Stamping & Rapid Mobilization", d: "After screening and shortlisting, we take swift action to get candidates ready for deployment. We handle all visa stamping procedures with precision and full regulatory compliance — mobilizing selected candidates to KSA within 15 days, minimizing downtime." },
      ],
    },
    history: {
      overline: "Our History",
      title: "Taking a Look Back",
      items: [
        { year: "1999", t: "The Beginning in Mumbai", d: "Founded in Mumbai as a humble staffing agency, dedicated to providing high-quality manpower to local companies." },
        { year: "2001", t: "Fast-Growing Company", d: "Within just two years, our reputation for excellence made us one of the fastest-growing staffing companies in the region." },
        { year: "2004", t: "Best Staffing Talent Award", d: "Our commitment to quality was recognized on a grand scale with the prestigious Best Staffing Talent Award." },
        { year: "2007", t: "100 Companies Tie-Up", d: "Successfully partnered with 100 local companies — a testament to our robust service delivery and long-term relationships." },
        { year: "2010", t: "Expanding Horizons", d: "Expanded beyond local boundaries to serve the growing demand for skilled manpower in the Gulf, particularly Saudi Arabia." },
        { year: "2013", t: "ISO Certification", d: "Our dedication to the highest quality standards was solidified with ISO certification." },
        { year: "2015", t: "Global Recognition", d: "Our relentless pursuit of excellence earned us several global awards in the international staffing industry." },
        { year: "2017", t: "Technological Advancements", d: "We embraced technology to streamline recruitment — faster, more efficient service that set new industry benchmarks." },
        { year: "2020", t: "Resilience and Growth", d: "Despite global challenges, we demonstrated remarkable resilience and continued to grow." },
        { year: "2023", t: "Leading the Industry", d: "With over two decades of experience, multiple awards and a strong global presence, Hire Host stands as a leader in manpower recruitment." },
      ],
    },
    manifesto: {
      overline: "Why Us", title: "Four Chapters of Trust",
      c1t: "25+ Years of Heritage", c1d: "Since 1998 we have built bridges of work between India and the Gulf. Thousands of companies trusted us; tens of thousands of families began new lives through us.",
      c2t: "100% Legal & Govt. Approved", c2d: "Ministry of External Affairs licence, Saudi Consulate card, and UN Global Marketplace registration. Every visa moves through official channels only.",
      c3t: "Precision Skill Testing", c3d: "Trade-test labs, technical Zoom interviews and QVP certification — we only deploy candidates who pass the full standard.",
      c4t: "Zero-Delay Dispatch", c4d: "From visa to boarding gate: biometrics, attestation, stamping and pre-departure orientation — all under one roof in Mumbai.",
    },
    solutions: {
      overline: "Our Solutions", title: "Inspiring Staffing Solutions",
      sub: "Innovative staffing solutions designed for your unique needs — industry expertise combined with cutting-edge technology.",
      more: "More Details",
      items: [
        { t: "Temporary Staffing", d: "Quickly address short-term staffing needs with our flexible temporary solutions." },
        { t: "Direct Hire", d: "Find the perfect permanent addition to your team with our direct hire services." },
        { t: "Contract Staffing", d: "Engage specialized talent for specific projects or time-bound assignments." },
        { t: "Payrolling", d: "Streamline your employment processes with our payrolling solutions." },
        { t: "Executive Search", d: "Connect with top-tier leadership talent through our executive search services." },
        { t: "Training & Development", d: "Upskill candidates with trade-specific training before deployment." },
      ],
    },
    staffing: {
      overline: "Staffing Services",
      title: "Hiring Solutions for Every Urgency",
      items: [
        { t: "Short Term Hiring", d: "Flexible short-term hiring for seasonal demands, projects and temporary gaps — skilled professionals on contract, without long-term commitments." },
        { t: "Last Minute Hiring", d: "Unexpected staffing needs? Our pool of pre-vetted professionals can step in at a moment's notice — with zero compromise on quality." },
        { t: "Immediate Hiring", d: "Fill emergency positions without delay — qualified, pre-screened candidates ready to start right away, keeping your operations running smoothly." },
      ],
    },
    tech: {
      overline: "Recruitment Technologies", title: "Solving Recruitment with Technology",
      sub: "We harness cutting-edge tools to streamline every step — from candidate search to final placement.",
      items: [
        { t: "India's Largest Database with AI Search", d: "Tap into India's most extensive talent pool — our algorithms identify the most suitable candidates instantly." },
        { t: "Unique ID & Password Access", d: "A secure, personalized portal experience for every client and candidate." },
        { t: "Real-Time Tracking & Updates", d: "Instant tracking throughout the recruitment process — from demand to deployment." },
        { t: "Automated Recruitment Solutions", d: "Automated systems reduce manual effort and speed up the recruitment cycle." },
      ],
    },
    industries: { overline: "Our Service Areas", title: "Industries We Serve", sub: "From hospitals to shipyards — the right talent for every sector." },
    vacancies: {
      overline: "Live Now", title: "Latest Vacancies",
      sub: "Fresh requirements from our Gulf clients — apply today and start your journey.",
      all: "All", openings: "Openings", salary: "Monthly Salary", apply: "Apply Now",
      empty: "No vacancies right now — check back soon",
    },
    hires: {
      overline: "Success Stories", title: "Latest Hires Deployed",
      sub: "Real faces who flew to the Gulf this month through Hire Host.", verified: "Verified",
    },
    process: {
      overline: "Your Journey, Step by Step", title: "From Demand to Departure",
      steps: [
        { t: "Selection & Sourcing", d: "We receive the demand and source candidates from our pan-India database." },
        { t: "Zoom Interview", d: "Live technical interview between employer and candidate, online or in person." },
        { t: "Shortlisting", d: "Final shortlist prepared and approved by the employer." },
        { t: "Medical Screening", d: "GAMCA-approved medical examination for Gulf countries." },
        { t: "Biometric Enrolment", d: "Fingerprint enrolment at authorised centres." },
        { t: "Skill Test / QVP / Attestation", d: "Trade test, QVP certification and document attestation (professionals only)." },
        { t: "Visa Stamping", d: "Visa stamping via Mumbai or Delhi consulate." },
        { t: "Orientation & Flight", d: "Pre-departure orientation, then boarding the flight." },
      ],
    },
    teambehind: {
      overline: "Team Behind Us", title: "Our Experience & Team",
      body: "Our manpower agency combines extensive experience with a dedicated team of experts to deliver tailored staffing solutions. We understand the challenges of finding skilled talent in today's market and are committed to connecting you with the right professionals quickly and efficiently.",
      temporary: "Temporary", contract: "Contract", direct: "Direct Hire", payrolling: "Payrolling",
      meet_all: "Meet All Team Members",
      leadership: "Our Leadership Team", leadership_sub: "Board of Directors & Senior Executives",
      executive: "Our Executive Team", executive_sub: "Team Behind Our Successful Service",
      r_founder: "Founder", r_mkt: "Overseas Marketing Head", r_ta: "Talent Acquisition Manager (Overseas)",
      r_hrexec: "HR Executive", r_tms: "Talent Management Specialist", r_hrofficer: "HR Officer",
      r_hradmin: "HR Administrator", r_chro: "Chief Human Resources Officer (CHRO)",
      r_hrgen: "HR Generalist", r_training: "Training & Development",
    },
    testisec: { overline: "Client Testimonials", title: "Highest Client Satisfaction Rate" },
    testis: [
      { q: "Working with Hire Host has been a game-changer for our recruitment process. As a leading petroleum company, we require a skilled workforce to maintain our high standards.", n: "Moataz Al Riyami", c: "Petroleum Development Oman" },
      { q: "Working with Hire Host has been an absolute game-changer. Their understanding of our specific needs made the recruitment process seamless.", n: "Fahad Al Thani", c: "HR Manager — Friendly Food Qatar" },
      { q: "Hire Host is more than just a recruitment partner — they are a vital part of our business success.", n: "Abdullah Al Juhani", c: "Alanud Arabia Trading Co." },
      { q: "An exceptional partner in fulfilling our manpower needs. We trust Hire Host to deliver top-notch talent, and they have never disappointed us.", n: "Nayaf Al Shammari", c: "Bateel Dates — Saudi Arabia" },
      { q: "An exceptional experience. Their professionalism and commitment to finding the right candidates have been truly impressive.", n: "Ahmet Kaya", c: "Damate Group — Turkey" },
    ],
    awardssec: { overline: "Our Excellence", title: "Awards & Major Achievements", sub: "From 1999 to today — a journey of accolades reflecting our commitment to quality and innovation." },
    awards: [
      { year: "1999–2001", t: "Foundation & Early Recognition", d: "Launched in Mumbai — recognized among the fastest-growing staffing companies in the region." },
      { year: "2004", t: "Best Staffing Talent Award", d: "Prestigious award for exceptional service and innovative recruitment practices." },
      { year: "2007", t: "100 Company Tie-Ups", d: "A major milestone of partnerships with 100 companies — proof of growing industry trust." },
      { year: "2010–2013", t: "Gulf Expansion & ISO", d: "Expanded to Saudi Arabia & the Gulf, earned ISO certification and several global awards." },
    ],
    clientssec: { overline: "Partners in Success", title: "Clients Who Trust Us" },
    faq: {
      overline: "FAQ", title: "Things You Need to Know",
      sub: "Answers to the most common questions from employers and candidates.",
      items: [
        { q: "What kind of services do you offer?", a: "Temporary staffing, direct hire, contract staffing, payrolling, executive search and training — across 12+ industry verticals." },
        { q: "How do I start hiring with you?", a: "Send your requirement through our inquiry form with a demand letter — our team contacts you within 24 hours to document every detail." },
        { q: "What is the candidate approval process?", a: "We document your need, source candidates, arrange Zoom interviews, and prepare a shortlist — you approve the final selection." },
        { q: "How long does deployment take?", a: "4 to 8 weeks overall. After final selection, visa stamping and mobilization to KSA happens within 15 days." },
        { q: "Do candidates pay any fee?", a: "It depends on the company. When the employer pays our charges, the service is completely free for the candidate; otherwise only a partial service charge applies." },
        { q: "What is contractual staffing?", a: "Engaging specialized talent for specific projects or time-bound assignments — the right expertise when you need it, without long-term commitments." },
        { q: "Which countries do you serve?", a: "Saudi Arabia, UAE, Qatar, Kuwait, Bahrain and Oman — via our Mumbai and Delhi consulate desks." },
        { q: "What documents does a candidate need?", a: "A passport valid for at least one year, photographs, and attested educational certificates for professional categories only." },
      ],
    },
    apply: {
      overline: "Apply Now", title: "Your Dream Job Starts Here",
      sub: "We're committed to fulfilling your unique career needs. Fill out the form below and we'll be in touch shortly.",
      name: "Full Name", phone: "Mobile Number", email: "Email Address",
      category: "Professional Category", experience: "Years of Experience", gulf: "Gulf Experience?",
      city: "Current City", notes: "Tell Us About Yourself", submit: "Submit Application",
      success: "Application received! Our recruitment team will contact you shortly.", error: "Something went wrong — please try again",
    },
    contact: {
      overline: "Contact Us", title: "Let's Talk About Your Needs",
      sub: "Smarter business solutions. Better customer relations. Our team is ready to answer every question.",
      location: "Our Location", hours_t: "Office Hours", hours: "Mon – Sat: 11:00am – 5:00pm • Sunday: Closed",
      looking: "What are you looking for?", hiring: "Hiring Employees", job: "Looking for a Job",
      message: "Your Message", send: "Send Message", success: "Message received! We'll get back to you shortly.",
      call_email: "Call or Email",
    },
    employer: {
      overline: "Employer Portal", title: "Request the Right Manpower for Your Business",
      tc_title: "Terms & Conditions",
      tc: [
        "Provide an attested Demand Letter and Power of Attorney (Chamber of Commerce + Indian Consulate).",
        "Attach visa copies or the electronic Wakala authorisation number.",
        "Recruitment fee applies and depends on the category and sector — no recruitment fee for labour manpower; skilled and professional categories are quoted per agreement.",
        "Approximate processing time: 4 to 8 weeks depending on category and consulate.",
        "3-month candidate replacement guarantee as per agreement terms.",
        "All candidates undergo approved medical tests and skill assessments before departure.",
      ],
      cats_title: "Categories We Provide", form_title: "Inquiry Form",
      form_sub: "Add every category you need with its details, then send — our team will contact you within 24 hours.",
    },
    employee: {
      overline: "Job Seeker Portal", title: "Your Gulf Career Starts Here",
      tc_title: "Application Terms",
      tc: [
        "Passport valid for at least one year.",
        "Pass the approved GAMCA medical examination.",
        "Pass the technical interview and trade test for skilled categories.",
        "Agency service charges may apply depending on the company: when the employer pays our charges the service is free for you; otherwise only a partial service charge applies. Never pay any unauthorised agent.",
        "Attested educational documents required for professional categories only.",
        "Full commitment to the employment contract and destination country laws.",
      ],
      jobs_title: "Latest Job Postings", cta: "Apply Now",
    },
    form: {
      company_name: "Company / Establishment Name", entity_type: "Entity Type",
      muassasa: "Establishment (Muassasa)", shirka: "Company (Shirka)", individual: "Individual",
      contact_person: "Contact Person", phone: "Mobile Number", email: "Email Address",
      category: "Required Category", category_other: "Type the category", workers: "Number of Workers",
      salary: "Salary (SAR)", profession_visa: "Profession on Visa",
      experience: "Experience Required", years: "years",
      gulf_exp: "Gulf Experience?", gulf_hint: "If you select No, Indian experience is accepted",
      yes: "Yes", no: "No", consulate: "Consulate", mumbai: "Mumbai", delhi: "Delhi",
      driver_license: "Driving Licence", with_saudi: "With Saudi Licence", without_license: "Without Saudi Licence",
      driver_for: "Driver For", house: "House", company: "Company",
      duty: "Duty Hours", hours: "hours", shift: "Shift",
      add_category: "Add This Category", added: "Added Requirements", remove: "Remove",
      notes: "Additional Notes", submit: "Send Inquiry",
      success: "Inquiry received! Our team will contact you within 24 hours.",
      error: "Something went wrong — please try again", required: "Add at least one category",
    },
    categories: {
      healthcare: "Hospital & Healthcare", construction: "Construction & Engineering", oilgas: "Oil & Gas",
      transport: "Transport & Heavy Equipment", mechanical: "Mechanical Industry", business: "Business Administration",
      finance: "Finance & Accounts", garment: "Garment Industry", fabrication: "Fabrication Industry",
      shipbuilding: "Ship Building & Repair", hospitality: "Hospitality & Hotels", it: "Information Technology",
      skilled: "Skilled Professionals", unskilled: "Unskilled Labour", driver: "Driver (Heavy / Light)", other: "Other",
    },
    login: {
      employer_title: "Employer Login", employee_title: "Candidate Login",
      email: "Email Address", password: "Password", submit: "Sign In",
      soon: "Portal launching soon — sign-in will be activated shortly", back: "Back to Home",
    },
    admin: {
      login_title: "Hire Host Control Panel", login_sub: "Admin access only",
      vacancies: "Vacancies", hires: "Hires", inquiries: "Inquiries", applications: "Job Applications",
      add_vacancy: "Add Vacancy", add_hire: "Add Hire",
      title_field: "Job Title", country: "Country", industry: "Industry",
      salary: "Salary", currency: "Currency", openings: "Openings",
      name: "Name", profession: "Profession", visa_status: "Visa Status",
      photo: "Photo", photo_url: "Or external image URL",
      save: "Save", delete: "Delete", logout: "Logout", status: "Status",
      new: "New", contacted: "Contacted", closed: "Closed",
      no_inquiries: "No inquiries yet", no_applications: "No applications yet",
      saved: "Saved successfully", deleted: "Deleted",
      login_success: "Welcome back", login_error: "Invalid credentials",
    },
    footer: {
      about: "A government-licensed international recruitment agency — connecting Indian talent with Gulf employers since 1998.",
      contact: "Contact Us", for_employers: "For Employers", for_employees: "For Job Seekers",
      office: "Office No. 713, Building No. 03, Navjivan Society, Lamington Road, Mumbai Central (E), Mumbai 400008",
      rights: "All rights reserved", license: "Licence: B-0377/MOM/PER/+1000/5/5037/98", links: "Quick Links",
    },
  },

  tr: {
    brand: "Hire Host",
    tagline: "Daha İyi Bir Yarın İçin",
    nav: {
      home: "Ana Sayfa", about: "Hakkımızda", about_company: "Şirketimiz", meet_team: "Ekibimizle Tanışın",
      employers: "İşverenler", overview: "Genel Bakış", place_order: "İş Emri Verin",
      solutions: "Çözümler", our_solutions: "Çözümlerimiz", staffing_service: "Personel Hizmetleri",
      jobseekers: "İş Arayanlar", js_overview: "Genel Bakış", job_openings: "İş İlanları",
      apply_now: "Hemen Başvur", faq: "SSS", testimonials_menu: "Referanslar",
      contact: "İletişim", employer_login: "İşveren Girişi", employee_login: "Aday Girişi",
      inquire: "İşgücü Talep Et", admin: "Yönetim",
    },
    hero: {
      overline: "Hindistan Dışişleri Bakanlığı Lisanslı • ISO 9001:2015",
      l1: "Hassas İşe Alım.", l2: "Özenle Seçilmiş Yetenek.", l3: "Garantili Sonuçlar.",
      sub: "1998'den beri Hindistan'ın en iyi işgücünü Körfez işverenleriyle buluşturuyoruz — şoförlerden teknisyenlere, mühendislerden sağlık personeline. Tam devlet lisansı ve her vize için canlı takip.",
      cta1: "İşgücü Talep Et", cta2: "İlanları Gör", scroll: "Keşfetmek için kaydır",
    },
    stats: { years: "Yıllık Deneyim", companies: "Anlaşmalı Şirket", recruitments: "Tamamlanan Yerleştirme", industries: "Sektör" },
    marquee: ["MEA Lisansı: B-0377/MOM/PER/+1000/5/5037/98", "ISO 9001:2015 — Bureau Veritas", "Suudi Konsolosluk Kartı: 354/98/23/E", "BM Küresel Pazarı Kayıtlı", "Hint Ticaret Odası Üyesi", "Biyometrik • QVP • Tasdik Merkezi"],
    aboutsec: {
      overline: "Acentamız Hakkında",
      title: "Hire Host India'ya Hoş Geldiniz",
      body: "Otuz yılı aşkın süredir Hire Host, işe alım sektörünün köşe taşıdır — Hindistan'ın en iyi yeteneklerini Körfez'deki, özellikle Suudi Arabistan'daki önde gelen şirketlerle buluşturma konusunda uzmanlaşmıştır. Değerli müşterilerimiz çok uluslu şirketlerden önde gelen yerel işletmelere kadar uzanır ve işgücü ihtiyaçlarını hassasiyet ve mükemmellikle karşılamamıza güvenirler. Kapsamlı hizmetlerimiz vasıflı işçilerden teknisyenlere, mühendislerden doktorlara kadar geniş bir rol yelpazesini kapsar. Sıkı seçim sürecimizle gurur duyuyoruz — sunduğumuz her adayın en yüksek profesyonellik ve uzmanlık standartlarını karşılamasını sağlıyoruz.",
    },
    welcome: {
      overline: "Hire Host India'ya Hoş Geldiniz",
      title: "Modern Çağın İşe Alım Ajansı",
      sub: "Yetenek kazanımını yeniden tanımlıyoruz: dijital çağın değişen işgücü ihtiyaçlarına uyum sağlayan modern ajans.",
      emp_t: "İşverenler İçin",
      emp_d: "Kuruluşunuz için ideal yeteneği kolayca keşfedin. İlk görüşmeden son yerleştirmeye kadar işe alımı basit ve verimli hale getiriyoruz.",
      emp_points: ["İhtiyacınızı Anlıyoruz", "Mükemmel Adayı Buluyoruz", "Kişiye Özel Eşleştirme", "Hızlı İşe Başlatma"],
      job_t: "İş Arayanlar İçin",
      job_d: "Hire Host India ile kariyer yolunuzu keşfedin — yetenekleriniz Körfez'de doğru yerini bulsun.",
      job_points: ["Kariyer Yolunuzu Keşfedin", "İşveren Ücreti Karşıladığında Ücretsiz", "Eğitim Kaynakları ve Rehberler", "Gerçek Zamanlı Başvuru Takibi"],
      explore: "Daha Fazla",
    },
    how: {
      overline: "Nasıl Çalışıyoruz",
      title: "Planımız ve Çalışma Tarzımız",
      sub: "Doğru yeteneğin doğru fırsatla buluşmasını sağlayan akıcı bir süreç.",
      steps: [
        { t: "İşverenden Talep Alınması", d: "Sürecimizi işverenlerle yakın işbirliği içinde başlatıyoruz. Ekibimiz her gereksinimi yakalamak için detaylı görüşmeler yapar — işverenin beklentileri ve standartlarıyla tam uyum sağlayarak, rol ve kurum kültürüne mükemmel uyan adaylar sunarız." },
        { t: "Başvuru Eleme ve Mülakat Planlama", d: "Titiz eleme sürecimiz yalnızca en nitelikli adayların değerlendirilmesini sağlar. Başvuruları katı kriterlere göre değerlendirir, kapsamlı geçmiş kontrolleri yapar ve beceri ile uyumu ölçen mülakatlar düzenleriz." },
        { t: "Vize Damgası ve Hızlı Sevk", d: "Eleme ve kısa listenin ardından adayları hızla gönderime hazırlarız. Tüm vize damgalama işlemlerini tam mevzuat uyumuyla hassasiyetle yürütürüz — seçilen adayları 15 gün içinde Suudi Arabistan'a sevk ederek zaman kaybını en aza indiririz." },
      ],
    },
    history: {
      overline: "Tarihçemiz",
      title: "Geçmişe Bir Bakış",
      items: [
        { year: "1999", t: "Mumbai'de Başlangıç", d: "Yerel şirketlere yüksek kaliteli işgücü sağlamaya adanmış mütevazı bir ajans olarak Mumbai'de kuruldu." },
        { year: "2001", t: "Hızla Büyüyen Şirket", d: "Sadece iki yılda mükemmellik itibarımız bizi bölgenin en hızlı büyüyen ajanslarından biri yaptı." },
        { year: "2004", t: "En İyi Yetenek Ödülü", d: "Kaliteye bağlılığımız prestijli En İyi Yetenek Ödülü ile taçlandı." },
        { year: "2007", t: "100 Şirket Anlaşması", d: "100 yerel şirketle başarılı ortaklık — güçlü hizmet anlayışımızın ve uzun vadeli ilişkilerimizin kanıtı." },
        { year: "2010", t: "Ufukları Genişletmek", d: "Körfez'de, özellikle Suudi Arabistan'da artan vasıflı işgücü talebini karşılamak için sınırların ötesine geçtik." },
        { year: "2013", t: "ISO Sertifikası", d: "En yüksek kalite standartlarına bağlılığımız ISO sertifikası ile pekişti." },
        { year: "2015", t: "Küresel Tanınırlık", d: "Amansız mükemmellik arayışımız bize uluslararası arenada çok sayıda ödül kazandırdı." },
        { year: "2017", t: "Teknolojik İlerlemeler", d: "İşe alımı hızlandıran teknolojileri benimsedik — sektörde yeni ölçütler belirledik." },
        { year: "2020", t: "Direnç ve Büyüme", d: "Küresel zorluklara rağmen olağanüstü direnç gösterdik ve büyümeye devam ettik." },
        { year: "2023", t: "Sektör Lideri", d: "Yirmi yılı aşkın deneyim, çok sayıda ödül ve güçlü küresel varlıkla Hire Host sektörün lideridir." },
      ],
    },
    manifesto: {
      overline: "Neden Biz", title: "Dört Güven Bölümü",
      c1t: "25+ Yıllık Miras", c1d: "1998'den beri Hindistan ile Körfez arasında iş köprüleri kuruyoruz. Binlerce şirket bize güvendi; on binlerce aile bizimle yeni bir hayata başladı.",
      c2t: "%100 Yasal ve Devlet Onaylı", c2d: "Dışişleri Bakanlığı lisansı, Suudi Konsolosluk kartı ve BM Küresel Pazar kaydı. Her vize yalnızca resmi kanallardan geçer.",
      c3t: "Hassas Beceri Testleri", c3d: "Meslek testi laboratuvarları, teknik Zoom mülakatları ve QVP sertifikası — yalnızca tam standardı geçen adayları göndeririz.",
      c4t: "Sıfır Gecikmeli Gönderim", c4d: "Vizeden uçak kapısına: biyometrik, tasdik, vize damgası ve uçuş öncesi oryantasyon — hepsi Mumbai'de tek çatı altında.",
    },
    solutions: {
      overline: "Çözümlerimiz", title: "İlham Veren İstihdam Çözümleri",
      sub: "Benzersiz ihtiyaçlarınız için tasarlanmış yenilikçi çözümler — sektör uzmanlığı ve son teknoloji bir arada.",
      more: "Detaylar",
      items: [
        { t: "Geçici Personel", d: "Kısa vadeli personel ihtiyaçlarınızı esnek geçici çözümlerimizle hızla karşılayın." },
        { t: "Doğrudan İşe Alım", d: "Doğrudan işe alım hizmetlerimizle ekibinize kalıcı ve mükemmel katkıyı bulun." },
        { t: "Sözleşmeli Personel", d: "Belirli projeler veya süreli görevler için uzman yeteneklerden yararlanın." },
        { t: "Bordrolama", d: "Bordrolama çözümlerimizle istihdam süreçlerinizi kolaylaştırın." },
        { t: "Üst Düzey Yönetici Arama", d: "Yönetici arama hizmetlerimizle en üst düzey liderlik yeteneklerine ulaşın." },
        { t: "Eğitim ve Gelişim", d: "Gönderim öncesi adayları mesleki eğitimle donatıyoruz." },
      ],
    },
    staffing: {
      overline: "Personel Hizmetleri",
      title: "Her Aciliyet İçin İşe Alım Çözümleri",
      items: [
        { t: "Kısa Vadeli İşe Alım", d: "Sezonluk talepler, projeler ve geçici boşluklar için esnek çözümler — uzun vadeli taahhüt olmadan sözleşmeli vasıflı profesyoneller." },
        { t: "Son Dakika İşe Alımı", d: "Beklenmedik ihtiyaçlar mı? Önceden incelenmiş aday havuzumuz anında devreye girer — kaliteden sıfır ödünle." },
        { t: "Acil İşe Alım", d: "Acil pozisyonları gecikmeden doldurun — hemen başlamaya hazır, ön elemeyi geçmiş adaylarla operasyonlarınız aksamadan sürer." },
      ],
    },
    tech: {
      overline: "İşe Alım Teknolojileri", title: "İşe Alımı Teknolojiyle Çözüyoruz",
      sub: "Aday aramadan yerleştirmeye kadar her adımı en yeni araçlarla kolaylaştırıyoruz.",
      items: [
        { t: "Hindistan'ın En Büyük Veri Tabanı + Yapay Zeka", d: "Hindistan'ın en geniş yetenek havuzuna erişin — algoritmalarımız en uygun adayları anında bulur." },
        { t: "Özel Kullanıcı Adı ve Şifre Erişimi", d: "Her müşteri ve aday için güvenli, kişiselleştirilmiş portal deneyimi." },
        { t: "Gerçek Zamanlı Takip ve Güncellemeler", d: "Talepten gönderime kadar tüm süreçte anlık takip." },
        { t: "Otomatik İşe Alım Çözümleri", d: "Otomatik sistemler manuel çabayı azaltır ve işe alım döngüsünü hızlandırır." },
      ],
    },
    industries: { overline: "Hizmet Alanlarımız", title: "Hizmet Verdiğimiz Sektörler", sub: "Hastanelerden tersanelere — her sektör için doğru yetenek." },
    vacancies: {
      overline: "Şu An Yayında", title: "En Yeni İş İlanları",
      sub: "Körfez müşterilerimizden güncel fırsatlar — bugün başvurun, yolculuğunuzu başlatın.",
      all: "Tümü", openings: "Açık Pozisyon", salary: "Aylık Maaş", apply: "Başvur",
      empty: "Şu anda ilan yok — yakında tekrar kontrol edin",
    },
    hires: {
      overline: "Başarı Hikayeleri", title: "Son Yerleştirilen Adaylar",
      sub: "Bu ay Hire Host ile Körfez'e uçan gerçek yüzler.", verified: "Doğrulandı",
    },
    process: {
      overline: "Adım Adım Yolculuğunuz", title: "Talepten Uçağa",
      steps: [
        { t: "Seçim ve Tedarik", d: "Talebi alır ve Hindistan genelindeki veri tabanımızdan adayları seçeriz." },
        { t: "Zoom Mülakatı", d: "İşveren ile aday arasında canlı teknik mülakat, çevrimiçi veya yüz yüze." },
        { t: "Kısa Liste", d: "Nihai kısa liste hazırlanır ve işveren tarafından onaylanır." },
        { t: "Sağlık Taraması", d: "Körfez ülkeleri için GAMCA onaylı sağlık muayenesi." },
        { t: "Biyometrik Kayıt", d: "Yetkili merkezlerde parmak izi kaydı." },
        { t: "Beceri Testi / QVP / Tasdik", d: "Meslek testi, QVP sertifikası ve belge tasdiki (yalnızca profesyoneller)." },
        { t: "Vize Damgası", d: "Mumbai veya Delhi konsolosluğu üzerinden vize damgası." },
        { t: "Oryantasyon ve Uçuş", d: "Uçuş öncesi oryantasyon, ardından uçağa biniş." },
      ],
    },
    teambehind: {
      overline: "Ekibimiz", title: "Deneyim ve Ekibimiz",
      body: "Acentamız, geniş deneyimi uzman ekibimizle birleştirerek size özel istihdam çözümleri sunar. Bugünün pazarında vasıflı yetenek bulmanın zorluklarını anlıyor ve sizi doğru profesyonellerle hızla buluşturmayı taahhüt ediyoruz.",
      temporary: "Geçici", contract: "Sözleşmeli", direct: "Doğrudan İşe Alım", payrolling: "Bordrolama",
      meet_all: "Tüm Ekip Üyeleriyle Tanışın",
      leadership: "Liderlik Ekibimiz", leadership_sub: "Yönetim Kurulu ve Kıdemli Yöneticiler",
      executive: "Yönetici Ekibimiz", executive_sub: "Başarılı Hizmetimizin Arkasındaki Ekip",
      r_founder: "Kurucu", r_mkt: "Yurtdışı Pazarlama Müdürü", r_ta: "Yetenek Kazanım Müdürü (Yurtdışı)",
      r_hrexec: "İK Uzmanı", r_tms: "Yetenek Yönetimi Uzmanı", r_hrofficer: "İK Yetkilisi",
      r_hradmin: "İK Yöneticisi", r_chro: "İnsan Kaynakları Direktörü (CHRO)",
      r_hrgen: "İK Generalisti", r_training: "Eğitim ve Gelişim",
    },
    testisec: { overline: "Müşteri Yorumları", title: "En Yüksek Müşteri Memnuniyeti" },
    testis: [
      { q: "Hire Host ile çalışmak işe alım sürecimizde tam bir dönüm noktası oldu. Önde gelen bir petrol şirketi olarak yüksek standartlarımız için vasıflı işgücüne ihtiyacımız var.", n: "Moataz Al Riyami", c: "Petroleum Development Oman" },
      { q: "Özel ihtiyaçlarımızı anlamaları işe alım sürecini kusursuz hale getirdi.", n: "Fahad Al Thani", c: "İK Müdürü — Friendly Food Qatar" },
      { q: "Hire Host sadece bir işe alım ortağı değil — iş başarımızın hayati bir parçası.", n: "Abdullah Al Juhani", c: "Alanud Arabia Trading Co." },
      { q: "İşgücü ihtiyaçlarımızı karşılamada olağanüstü bir ortak. Bizi hiç hayal kırıklığına uğratmadılar.", n: "Nayaf Al Shammari", c: "Bateel Dates — Suudi Arabistan" },
      { q: "Profesyonellikleri ve doğru adayları bulma konusundaki kararlılıkları gerçekten etkileyici.", n: "Ahmet Kaya", c: "Damate Group — Türkiye" },
    ],
    awardssec: { overline: "Mükemmelliğimiz", title: "Ödüller ve Büyük Başarılar", sub: "1999'dan bugüne — kalite ve yenilik taahhüdümüzü yansıtan ödüller yolculuğu." },
    awards: [
      { year: "1999–2001", t: "Kuruluş ve Erken Takdir", d: "Mumbai'de kurulduk — bölgenin en hızlı büyüyen istihdam şirketleri arasında gösterildik." },
      { year: "2004", t: "En İyi Yetenek Ödülü", d: "Olağanüstü hizmet ve yenilikçi işe alım uygulamaları için prestijli ödül." },
      { year: "2007", t: "100 Şirket Anlaşması", d: "100 şirketle ortaklık kilometre taşı — artan sektör güveninin kanıtı." },
      { year: "2010–2013", t: "Körfez Genişlemesi ve ISO", d: "Suudi Arabistan ve Körfez'e açıldık, ISO sertifikası ve çok sayıda küresel ödül kazandık." },
    ],
    clientssec: { overline: "Başarı Ortakları", title: "Bize Güvenen Müşteriler" },
    faq: {
      overline: "SSS", title: "Bilmeniz Gerekenler",
      sub: "İşverenlerin ve adayların en sık sorduğu soruların yanıtları.",
      items: [
        { q: "Hangi hizmetleri sunuyorsunuz?", a: "Geçici personel, doğrudan işe alım, sözleşmeli personel, bordrolama, yönetici arama ve eğitim — 12'den fazla sektörde." },
        { q: "Sizinle işe alıma nasıl başlarım?", a: "Talep mektubunuzla birlikte talep formunu gönderin — ekibimiz 24 saat içinde sizinle iletişime geçer." },
        { q: "Aday onay süreci nasıl işler?", a: "İhtiyacınızı belgeliyoruz, adayları tedarik ediyoruz, Zoom mülakatları düzenliyoruz ve kısa liste hazırlıyoruz — nihai seçimi siz onaylıyorsunuz." },
        { q: "Gönderim ne kadar sürer?", a: "Toplam 4-8 hafta. Nihai seçimden sonra vize damgası ve Suudi Arabistan'a sevk 15 gün içinde gerçekleşir." },
        { q: "Adaylar ücret ödüyor mu?", a: "Şirkete bağlıdır. İşveren ücretimizi karşılıyorsa hizmet aday için tamamen ücretsizdir; aksi halde yalnızca kısmi hizmet bedeli uygulanır." },
        { q: "Sözleşmeli personel nedir?", a: "Belirli projeler veya süreli görevler için uzman yetenek — uzun vadeli taahhüt olmadan doğru zamanda doğru uzmanlık." },
        { q: "Hangi ülkelere hizmet veriyorsunuz?", a: "Suudi Arabistan, BAE, Katar, Kuveyt, Bahreyn ve Umman — Mumbai ve Delhi konsolosluk masalarımızla." },
        { q: "Adayın hangi belgelere ihtiyacı var?", a: "En az bir yıl geçerli pasaport, fotoğraf ve yalnızca profesyonel kategoriler için tasdikli eğitim belgeleri." },
      ],
    },
    apply: {
      overline: "Hemen Başvur", title: "Hayalinizdeki İş Burada Başlıyor",
      sub: "Benzersiz kariyer ihtiyaçlarınızı karşılamaya kararlıyız. Formu doldurun, kısa sürede size dönelim.",
      name: "Ad Soyad", phone: "Cep Telefonu", email: "E-posta Adresi",
      category: "Meslek Kategorisi", experience: "Deneyim Yılı", gulf: "Körfez Deneyimi?",
      city: "Mevcut Şehir", notes: "Kendinizden Bahsedin", submit: "Başvuruyu Gönder",
      success: "Başvurunuz alındı! İşe alım ekibimiz kısa sürede sizinle iletişime geçecek.", error: "Bir hata oluştu — lütfen tekrar deneyin",
    },
    contact: {
      overline: "İletişim", title: "İhtiyacınızı Konuşalım",
      sub: "Daha akıllı iş çözümleri. Daha iyi müşteri ilişkileri. Ekibimiz her sorunuzu yanıtlamaya hazır.",
      location: "Adresimiz", hours_t: "Çalışma Saatleri", hours: "Pzt – Cmt: 11:00 – 17:00 • Pazar: Kapalı",
      looking: "Ne arıyorsunuz?", hiring: "Personel Alımı", job: "İş Arıyorum",
      message: "Mesajınız", send: "Mesajı Gönder", success: "Mesajınız alındı! Kısa sürede size döneceğiz.",
      call_email: "Arayın veya Yazın",
    },
    employer: {
      overline: "İşveren Portalı", title: "İşletmeniz İçin Doğru İşgücünü Talep Edin",
      tc_title: "Şartlar ve Koşullar",
      tc: [
        "Tasdikli Talep Mektubu (Demand Letter) ve Vekaletname (Power of Attorney) sunulmalıdır.",
        "Vize kopyaları veya elektronik Vekaletnâme (Wakala) numarası eklenmelidir.",
        "İşe alım ücreti kategori ve sektöre göre değişir — işçi (labour) istihdamında işverenden ücret alınmaz; vasıflı ve profesyonel kategoriler anlaşmaya göre fiyatlandırılır.",
        "Yaklaşık işlem süresi: kategoriye ve konsolosluğa göre 4-8 hafta.",
        "Anlaşma şartlarına göre 3 aylık aday değişim garantisi.",
        "Tüm adaylar uçuş öncesi onaylı sağlık testi ve beceri değerlendirmesinden geçer.",
      ],
      cats_title: "Sağladığımız Kategoriler", form_title: "Talep Formu",
      form_sub: "İhtiyacınız olan her kategoriyi detaylarıyla ekleyin ve gönderin — ekibimiz 24 saat içinde sizinle iletişime geçecek.",
    },
    employee: {
      overline: "İş Arayan Portalı", title: "Körfez Kariyeriniz Burada Başlıyor",
      tc_title: "Başvuru Şartları",
      tc: [
        "En az bir yıl geçerli pasaport.",
        "Onaylı GAMCA sağlık muayenesinden geçmek.",
        "Vasıflı kategoriler için teknik mülakat ve meslek testini geçmek.",
        "Şirkete bağlı olarak ajans hizmet bedeli uygulanabilir: işveren ücretimizi karşılıyorsa hizmet sizin için ücretsizdir; aksi halde yalnızca kısmi hizmet bedeli alınır. Yetkisiz aracılara asla ödeme yapmayın.",
        "Eğitim belgelerinin tasdiki yalnızca profesyonel kategoriler için gereklidir.",
        "İş sözleşmesine ve hedef ülke yasalarına tam bağlılık.",
      ],
      jobs_title: "En Yeni İş İlanları", cta: "Hemen Başvur",
    },
    form: {
      company_name: "Şirket / Kuruluş Adı", entity_type: "Kuruluş Türü",
      muassasa: "Kuruluş (Muassasa)", shirka: "Şirket (Shirka)", individual: "Bireysel",
      contact_person: "Yetkili Kişi", phone: "Cep Telefonu", email: "E-posta Adresi",
      category: "İstenen Kategori", category_other: "Kategoriyi yazın", workers: "İşçi Sayısı",
      salary: "Maaş (SAR)", profession_visa: "Vizedeki Meslek",
      experience: "Gereken Deneyim", years: "yıl",
      gulf_exp: "Körfez Deneyimi?", gulf_hint: "Hayır seçerseniz Hindistan deneyimi kabul edilir",
      yes: "Evet", no: "Hayır", consulate: "Konsolosluk", mumbai: "Mumbai", delhi: "Delhi",
      driver_license: "Ehliyet", with_saudi: "Suudi Ehliyetli", without_license: "Suudi Ehliyetsiz",
      driver_for: "Şoför Kimin İçin", house: "Ev", company: "Şirket",
      duty: "Mesai Saatleri", hours: "saat", shift: "Vardiya",
      add_category: "Bu Kategoriyi Ekle", added: "Eklenen Gereksinimler", remove: "Kaldır",
      notes: "Ek Notlar", submit: "Talebi Gönder",
      success: "Talebiniz alındı! Ekibimiz 24 saat içinde sizinle iletişime geçecek.",
      error: "Bir hata oluştu — lütfen tekrar deneyin", required: "En az bir kategori ekleyin",
    },
    categories: {
      healthcare: "Hastane ve Sağlık", construction: "İnşaat ve Mühendislik", oilgas: "Petrol ve Gaz",
      transport: "Nakliye ve Ağır Ekipman", mechanical: "Mekanik Sanayi", business: "İşletme Yönetimi",
      finance: "Finans ve Muhasebe", garment: "Hazır Giyim", fabrication: "Fabrikasyon",
      shipbuilding: "Gemi İnşa ve Onarım", hospitality: "Otelcilik ve Turizm", it: "Bilgi Teknolojileri",
      skilled: "Vasıflı Profesyoneller", unskilled: "Vasıfsız İşçi", driver: "Şoför (Ağır / Hafif)", other: "Diğer",
    },
    login: {
      employer_title: "İşveren Girişi", employee_title: "Aday Girişi",
      email: "E-posta Adresi", password: "Şifre", submit: "Giriş Yap",
      soon: "Portal yakında açılıyor — giriş kısa süre içinde aktif olacak", back: "Ana Sayfaya Dön",
    },
    admin: {
      login_title: "Hire Host Yönetim Paneli", login_sub: "Yalnızca yönetici erişimi",
      vacancies: "İlanlar", hires: "Yerleştirilenler", inquiries: "Talepler", applications: "İş Başvuruları",
      add_vacancy: "İlan Ekle", add_hire: "Aday Ekle",
      title_field: "Pozisyon", country: "Ülke", industry: "Sektör",
      salary: "Maaş", currency: "Para Birimi", openings: "Açık Pozisyon",
      name: "İsim", profession: "Meslek", visa_status: "Vize Durumu",
      photo: "Fotoğraf", photo_url: "Veya harici görsel URL'si",
      save: "Kaydet", delete: "Sil", logout: "Çıkış", status: "Durum",
      new: "Yeni", contacted: "İletişime Geçildi", closed: "Kapandı",
      no_inquiries: "Henüz talep yok", no_applications: "Henüz başvuru yok",
      saved: "Başarıyla kaydedildi", deleted: "Silindi",
      login_success: "Tekrar hoş geldiniz", login_error: "Geçersiz bilgiler",
    },
    footer: {
      about: "Devlet lisanslı uluslararası işe alım ajansı — 1998'den beri Hint yetenekleri Körfez işverenleriyle buluşturuyoruz.",
      contact: "Bize Ulaşın", for_employers: "İşverenler İçin", for_employees: "İş Arayanlar İçin",
      office: "Office No. 713, Building No. 03, Navjivan Society, Lamington Road, Mumbai Central (E), Mumbai 400008",
      rights: "Tüm hakları saklıdır", license: "Lisans: B-0377/MOM/PER/+1000/5/5037/98", links: "Hızlı Bağlantılar",
    },
  },
};

Object.keys(overview).forEach((l) => Object.assign(translations[l], overview[l]));

export const CATEGORY_KEYS = [
  "healthcare", "construction", "oilgas", "transport", "mechanical", "business",
  "finance", "garment", "fabrication", "shipbuilding", "hospitality", "it",
  "skilled", "unskilled", "driver", "other",
];
